// Shared client-side formatters for the Insider hub. The presenter sends ISO
// dates and integer cents (server-sourced from the real PriceList /
// SubscriptionPlan); formatting + savings-% live here so every Insider section
// renders money and dates the same way. Mirrors InsiderHelper#format_price_cents
// / #comparison_savings_pct.

export function formatDate(iso) {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
}

export function formatCents(cents) {
  if (cents == null) return "—"
  return `$${(cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export function savingsPct(standardCents, insiderCents) {
  if (standardCents == null || insiderCents == null || standardCents === 0) {
    return null
  }
  const pct = Math.round(((standardCents - insiderCents) / standardCents) * 100)
  return pct > 0 ? pct : null
}

// Whole dollars for headline figures ("$1,347", "Save $336").
export function formatDollars(cents) {
  if (cents == null) return "—"
  return `$${Math.round(cents / 100).toLocaleString("en-US")}`
}
